import {
  ChangeDetectionStrategy,
  Component,
  EffectRef,
  effect,
  inject,
  OnDestroy
} from '@angular/core';
import {MatAnchor, MatButtonModule} from '@angular/material/button';
import {MatIconModule} from '@angular/material/icon';
import {MatProgressSpinner} from '@angular/material/progress-spinner';
import {MatToolbarModule} from '@angular/material/toolbar';
import {RouterLink} from '@angular/router';
import {Store} from '@ngrx/store';
import {selectSelectedProject} from '../../../project/service/project.selectors';
import {loadResearchPapers} from '../../../research/services/research-paper/research-paper.actions';
import {selectEmbeddingAugmentorResults, selectEmbeddingLoading} from '../../service/embedding.selectors';
import {loadEmbeddingAugmentorResult} from '../../service/embedding.actions';
import {PaperEmbeddingPaperCardComponent} from '../paper-embedding-paper-card/paper-embedding-paper-card.component';
import {MatFormField, MatFormFieldModule} from '@angular/material/form-field';
import {MatInputModule} from '@angular/material/input';
import {FormsModule} from '@angular/forms';

@Component({
  selector: 'app-paper-embedding-augmentor-search',
  imports: [
    MatAnchor,
    MatIconModule,
    MatButtonModule,
    MatProgressSpinner,
    MatToolbarModule,
    RouterLink,
    PaperEmbeddingPaperCardComponent,
    MatFormField,
    MatInputModule,
    MatFormFieldModule,
    FormsModule
  ],
  templateUrl: './paper-embedding-augmentor-search.component.html',
  styleUrl: './paper-embedding-augmentor-search.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class PaperEmbeddingAugmentorSearchComponent implements OnDestroy {
  private readonly store: Store = inject(Store);

  query = '';
  passedQuery = '';
  readonly project = this.store.selectSignal(selectSelectedProject);
  readonly loading = this.store.selectSignal(selectEmbeddingLoading);
  readonly paperAugmentorResults = this.store.selectSignal(selectEmbeddingAugmentorResults);

  loadEmbeddingAugmentorEffectRef: EffectRef | undefined;

  constructor() {
    effect(() => {
      const project = this.project();
      if (!project) return;
      this.store.dispatch(loadResearchPapers({projectId: project.id}));
    });

    effect(() => {
      if (this.loading()) {
        this.query = '';
      }
    });
  }

  ngOnDestroy(): void {
    if (this.loadEmbeddingAugmentorEffectRef) {
      this.loadEmbeddingAugmentorEffectRef.destroy();
    }
  }

  queryEmbeddingAugmentor(): void {
    const project = this.project();
    if (!project) {
      return;
    }
    if (this.query === '') {
      return;
    }
    this.passedQuery = this.query;
    if (this.loadEmbeddingAugmentorEffectRef) {
      this.loadEmbeddingAugmentorEffectRef.destroy();
    }
    this.loadEmbeddingAugmentorEffectRef = this.store.dispatch(() => loadEmbeddingAugmentorResult(
      {
        projectId: project.id,
        query: this.query
      }));

  }

}
